import axios from "axios";
import { BACKEND_BASE_URL } from "../utils/constants";

const axiosInstance = axios.create({
  baseURL: BACKEND_BASE_URL,
});

axiosInstance.interceptors.response.use(
  (response) => response,
  (error) => {
    const status = error.response?.status || 500;
    const isErrorPage =
      window.location.pathname.includes("unauthorize") ||
      window.location.pathname.includes("sessao-expirada");

    if (status === 401) {
      if (!isErrorPage) {
        localStorage.setItem(
          "lastPathBeforeSessionExpired",
          window.location.pathname
        );
        setTimeout(() => {
          window.location.href = "/sessao-expirada";
        }, 50);
      }
    } else if (status === 403) {
      if (!isErrorPage) {
        setTimeout(() => {
          window.location.href = "/unauthorize";
        }, 50);
      }
    } else if (status === 404) {
      console.warn("Recurso não encontrado.");
    } else if (status === 500) {
      console.error("Erro interno do servidor.");
    }

    return Promise.reject(error);
  }
);

export default axiosInstance;
